import React from 'react'
import cx from 'classnames'
import Images from '/data/images'
import MicroModal from 'react-micro-modal'
import YouTube from 'react-youtube'
import Play from '/img/svg/play'
import Close from '/img/svg/close'

class Video extends React.Component {
  state = {
    videoInitialized: false,
    posterStatus: 'loading',
    width: 300,
    height: 150
  }

  handlePosterLoaded() {
    this.setState({ posterStatus: 'loaded' })
  }

  generatePlayerVars() {
    const { content } = this.props
    let playerVars = { autoplay: 1 }

    if (!!content.youtubePlaylistID) {
      playerVars['listType'] = 'playlist'
      playerVars['list'] = content.youtubePlaylistID
    }

    return playerVars
  }

  generateModalDimensions() {
    const browserWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    )

    const playerWidth =
      browserWidth > 1600 ? 1200 : Math.round(browserWidth * 0.75)
    const playerHeight = Math.round(playerWidth / 1.641025641)

    return { playerWidth, playerHeight }
  }

  renderInlineVideo() {
    if (!this.props.inline) {
      return null
    }

    if (!this.state.videoInitialized) {
      return null
    }

    const { content } = this.props
    const opts = {
      width: '100%',
      height: '100%',
      playerVars: this.generatePlayerVars()
    }

    return (
      <YouTube
        videoId={content.youtubeID}
        opts={opts}
        className="absolute inset-0"
      />
    )
  }

  renderModalVideo() {
    if (this.props.inline) {
      return null
    }

    const { content } = this.props
    const { playerWidth, playerHeight } = this.generateModalDimensions()
    const opts = {
      width: playerWidth,
      height: playerHeight,
      playerVars: this.generatePlayerVars()
    }
    const halfPlayerWidth = playerWidth / 2
    const halfPlayerHeight = playerHeight / 2

    return (
      <MicroModal
        open={this.state.videoInitialized}
        closeOnEscapePress={true}
        closeOnOverlayClick={true}
        modalOverlayClassName={`fixed inset-0 animate fade-in animation-slow z-top`}
        containerStyles={{ background: 'transparent' }}
        children={handleClose => (
          <div
            data-label="video-popup-wrapper"
            className="absolute z-50 animate translate-y-fade animation-slow animation-delay"
            style={{
              left: '50%',
              marginLeft: -halfPlayerWidth,
              top: '50%',
              marginTop: -halfPlayerHeight
            }}
          >
            <YouTube videoId={content.youtubeID} opts={opts} />
            <button
              data-label="video-popup-close-button"
              className="absolute top-10 right-10 -mr-20 -mt-20 translate-y-fade animation-slow animation-delay"
              onClick={() => this.setState({ videoInitialized: false })}
            >
              <span className="screenreader">Close</span>
              <span className="block w-48 h-48 bg-smoke-white rounded-full flex justify-center items-center">
                <Close />
              </span>
            </button>
          </div>
        )}
      />
    )
  }

  render() {
    const { content, theme, offsetButton, highlight } = this.props

    if (!content.youtubeID) {
      return null
    }

    return (
      <div className="relative w-full">
        <button
          className="w-full video-button group"
          data-label="video-open-button"
          onClick={() => this.setState({ videoInitialized: true })}
        >
          <span className="screenreader">Play related video</span>
          <div className="relative">
            <img
              data-label="video-poster"
              alt={content.images.description}
              className={cx('block mx-auto w-full', {
                'min-h-117': !highlight
              })}
              src={Images[content.images.key].defaultRes}
              srcSet={`${Images[content.images.key].defaultRes} 1x, ${Images[content.images.key].hiRes} 2x`}
              onLoad={() => this.handlePosterLoaded()}
              data-status={this.state.posterStatus}
              height={this.state.height}
              width={this.state.width}
            />

            <div
              data-label="video-play-icon"
              className={!offsetButton ? 'pulse' : ''}
            >
              <div
                className={cx('absolute z-10', {
                  [`bottom-half right-half w-40 h-40 md:w-90 md:h-90 -mr-20 -mb-20 md:-mr-45 md:-mb-45 ${theme.textColor}`]: !offsetButton,
                  'w-35 h-35 bottom-0 right-0 mr-10 mb-10': offsetButton
                })}
              >
                <Play />
              </div>
            </div>
          </div>
        </button>
        {this.renderModalVideo()}
        {this.renderInlineVideo()}
      </div>
    )
  }
}

export default Video
